import { render, staticRenderFns } from "./AppointmentOverview.vue?vue&type=template&id=23678df2&scoped=true"
import script from "./AppointmentOverview.vue?vue&type=script&lang=js"
export * from "./AppointmentOverview.vue?vue&type=script&lang=js"
import style0 from "./AppointmentOverview.vue?vue&type=style&index=0&id=23678df2&prod&scoped=true&lang=less"
import style1 from "./AppointmentOverview.vue?vue&type=style&index=1&id=23678df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23678df2",
  null
  
)

export default component.exports